import { useCompaniesSummaryCardQuery } from 'generated/graphql';
import React from 'react';



export type IMetric = {
  name: string;
  value: number;
  percentChangeMoM: number;
};

export type IData = {
  metrics: IMetric[];
};

export function useQuery() {
  const tuple = useCompaniesSummaryCardQuery({
  });

  return React.useMemo(
    () => {
      const metrics: IMetric[] = [
        {
          name: 'Total companies being tracked',
          value: tuple.data?.totalCompanies.value.toNumber() ?? 0,
          percentChangeMoM: tuple.data?.totalCompanies.changeMonthOverMonthPercent.toNumber() ?? 0
        },
        {
          name: 'Transcripts in the last 7 days',
          value: tuple.data?.totalCompaniesWithNewTranscripts.value.toNumber() ?? 0,
          percentChangeMoM: tuple.data?.totalCompaniesWithNewTranscripts.changeMonthOverMonthPercent.toNumber() ?? 0
        },
        {
          name: 'Companies with new 10-K/10-Q',
          value: tuple.data?.totalNewFilings.value.toNumber() ?? 0,
          percentChangeMoM: tuple.data?.totalNewFilings.changeMonthOverMonthPercent.toNumber() ?? 0
        },
        {
          name: 'Total Data Points in Sherlock',
          value: tuple.data?.totalDataPoints.value.toNumber() ?? 0,
          percentChangeMoM: tuple.data?.totalDataPoints.changeMonthOverMonthPercent.toNumber() ?? 0
        },
        {
          name: 'Number of Sherlock responses',
          value: tuple.data?.totalMessageCount.value.toNumber() ?? 0,
          percentChangeMoM: tuple.data?.totalMessageCount.changeMonthOverMonthPercent.toNumber() ?? 0
        }
      ];

      return {
        ...tuple,
        data: {
          metrics
        }
      };
    },
    [tuple]
  );
}
